import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useUserDispatch } from '../context/UserContext';

export const useSessionTimeout = () => {
  const history = useHistory();
  const dispatch = useUserDispatch();

  const INACTIVITY_TIMEOUT = 30 * 60 * 1000; // 2 minutes
  const ACTIVITY_KEY = 'lastActivityTime';

  useEffect(() => {
    let logoutTimer;

    const handleLogout = () => {
      localStorage.clear();
      sessionStorage.clear();

      dispatch({ type: 'SIGN_OUT_SUCCESS' });
      history.push('/login');
    };

    // 🔹 Reset timer based on latest activity (shared across tabs)
    const resetTimer = () => {
      if (logoutTimer) clearTimeout(logoutTimer);

      const lastActivity = Number(localStorage.getItem(ACTIVITY_KEY)) || Date.now();
      const timeLeft = INACTIVITY_TIMEOUT - (Date.now() - lastActivity);

      if (timeLeft <= 0) {
        handleLogout();
      } else {
        logoutTimer = setTimeout(handleLogout, timeLeft);
      }
    };

    // 🔹 When user is active in THIS tab
    const handleUserActivity = () => {
      localStorage.setItem(ACTIVITY_KEY, Date.now());
      resetTimer();
    };

    // 🔹 Listen to activity from OTHER tabs
    const handleStorageChange = (e) => {
      if (e.key === ACTIVITY_KEY) {
        resetTimer(); // sync timer across tabs
      }
    };

    const activityEvents = [
      'mousemove',
      'keydown',
      'click',
      'scroll',
      'touchstart',
    ];

    // Add listeners
    activityEvents.forEach((event) => {
      window.addEventListener(event, handleUserActivity);
    });

    window.addEventListener('storage', handleStorageChange);

    // Initialize activity time if not present
    if (!localStorage.getItem(ACTIVITY_KEY)) {
      localStorage.setItem(ACTIVITY_KEY, Date.now());
    }

    resetTimer();

    return () => {
      if (logoutTimer) clearTimeout(logoutTimer);

      activityEvents.forEach((event) => {
        window.removeEventListener(event, handleUserActivity);
      });

      window.removeEventListener('storage', handleStorageChange);
    };
  }, [dispatch, history]);
};